"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutgoingBeaconMessageInterceptor = void 0;
const __1 = require("..");
const constants_1 = require("../constants");
const crypto_1 = require("../utils/crypto");
const get_account_identifier_1 = require("../utils/get-account-identifier");
class OutgoingBeaconMessageInterceptor {
    static async intercept(config) {
        const { beaconId, request, message, permissionManager, appMetadataManager, interceptorCallback } = config;
        switch (message.type) {
            case __1.BeaconMessageType.PermissionResponse: {
                const response = {
                    beaconId,
                    version: constants_1.BEACON_VERSION,
                    ...message
                };
                // TODO: Migration code. Remove before 1.0.0 release.
                const publicKey = response.publicKey || response.pubkey || response.pubKey;
                const address = await crypto_1.getAddressFromPublicKey(publicKey);
                const appMetadata = await appMetadataManager.getAppMetadata(request.beaconId);
                if (!appMetadata) {
                    throw new Error('AppMetadata not found');
                }
                const permission = {
                    accountIdentifier: await get_account_identifier_1.getAccountIdentifier(address, response.network),
                    beaconId: request.beaconId,
                    appMetadata,
                    website: '',
                    address,
                    publicKey,
                    network: response.network,
                    scopes: response.scopes,
                    connectedAt: new Date().getTime()
                };
                permissionManager.addPermission(permission).catch(console.error);
                interceptorCallback(response);
                break;
            }
            case __1.BeaconMessageType.OperationResponse:
                {
                    const response = {
                        beaconId,
                        version: constants_1.BEACON_VERSION,
                        ...message
                    };
                    interceptorCallback(response);
                }
                break;
            case __1.BeaconMessageType.SignPayloadResponse:
                {
                    const response = {
                        beaconId,
                        version: constants_1.BEACON_VERSION,
                        ...message
                    };
                    interceptorCallback(response);
                }
                break;
            case __1.BeaconMessageType.BroadcastResponse:
                {
                    const response = {
                        beaconId,
                        version: constants_1.BEACON_VERSION,
                        ...message
                    };
                    interceptorCallback(response);
                }
                break;
            default:
                console.log('Message not handled');
        }
    }
}
exports.OutgoingBeaconMessageInterceptor = OutgoingBeaconMessageInterceptor;
//# sourceMappingURL=OutgoingBeaconMessageInterceptor.js.map